// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"875":"37c8b498","916":"a30ec465"}[chunkId] + ".chunk.css");